function get_init(){
  return {
    headers: {
      'content-type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    credentials: 'same-origin'
  };
};
function jsons(obj){
  return JSON.stringify(obj);
}
function post_init(o){
  const h = get_init();
  h.method = 'POST';
  h.body = jsons(o);
  return h;
}
function patch_init(o){
  const h = get_init();
  h.method = 'PATCH';
  h.body = jsons(o);
  return h;
}
function delete_init(o){
  const h = get_init();
  h.method = 'DELETE';
  return h;
}
function responsef(r){
  if(r.ok) {
    const type = r.headers.get("content-type");
    if (type && type.includes("application/json")) {
      return r.json();
    } else if (type && type.includes("text/xml")) {
      return r.text();
    } else if (type && type.includes("text/plain")) {
      return r.text();
    } else if (type && type.includes("audio/wav")) {
      return r.arrayBuffer();
    }
  }
  throw new Error('response error');
}
async function aa_get(url, params = {}){
    try {
        const query_params = new URLSearchParams(params).toString();
        const full_url = query_params ? `${url}?${query_params}` : url;

        const r = await fetch(full_url, get_init());
        return await responsef(r);
    } catch(error){
        console.error('Error:', error);
        throw error;
    }
}
async function aa_post(url, data = {}){
    try {
        const r = await fetch(url, post_init(data));
        return await responsef(r);
    } catch(error) {
        console.error('Error:', error);
        throw error;
    }
}
async function aa_patch(url, data = {}){
    try {
        const r = await fetch(url, patch_init(data));
        return await responsef(r);
    } catch(error) {
        console.error('Error:', error);
        throw error;
    }
}
async function aa_delete(url){
    try {
        const r = await fetch(url, delete_init());
        return await responsef(r);
    } catch(error) {
        console.error('Error:', error);
        throw error;
    }
}
function getp(url){
  return fetch(url, get_init()).then(responsef).catch(function(e) {
    return console.error('Error:', e);
  });
}
function postp(url, o){
  return fetch(url, post_init(o)).then(responsef).catch(function(e) {
    return console.error('Error:', e);
  });
}
function patchp(url, o){
  return fetch(url, patch_init(o)).then(responsef).catch(function(e) {
    return console.error('Error:', e);
  });
}
function deletep(url, o){
  return fetch(url, delete_init(o)).then(responsef).catch(function(e) {
    return console.error('Error:', e);
  });
}
export { aa_get, aa_post, aa_patch, aa_delete, getp, postp, patchp, deletep }
